import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { environment } from '@env'
import { UserProfile } from '@core/auth/models/auth.models'

@Injectable({ providedIn: 'root' })
export class ProfileApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchUserProfile(): Observable<HttpResponse<UserProfile>> {
    return this._http.get<UserProfile>(environment.api.userProfileUrl, { observe: 'response' })
  }

  saveUserAvatar(avatar: { encodedImage: string }): Observable<any> {
    return this._http.put(environment.api.avatarUrl, JSON.stringify(avatar))
  }

  saveUserProfile(profile: UserProfile): Observable<void> {
    return this._http.put<void>(environment.api.userProfileUrl, profile)
  }
}
